import type { ComponentProps } from 'react';
import {
  Pressable as RNPressable,
  type PressableProps as RNPressableProps,
} from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import type Box from './Box';

type PressableWebProps = {
  href?: string;
  target?: string;
};

export default function Pressable({
  children,
  style: extraStyles,
  styleOverride,
  onPress,
  ...props
}: ComponentProps<typeof Box> &
  RNPressableProps & {
    styleOverride?: ComponentProps<typeof RNPressable>['style'];
  } & PressableWebProps) {
  return (
    <RNPressable
      {...props}
      style={
        !styleOverride
          ? ({ pressed }) => [
              style.container(props.disabled),
              pressed && style.active,
              extraStyles,
            ]
          : styleOverride
      }
      onPress={onPress}
    >
      {children}
    </RNPressable>
  );
}

export const style = StyleSheet.create((theme) => ({
  container: (disabled: boolean | null | undefined) => ({
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    _web: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      _hover: !disabled
        ? {
            backgroundColor: theme.colors.surfaceSecondary,
          }
        : {},
    },
  }),
  active: {
    backgroundColor: theme.colors.surfaceSecondary,
  },
}));
